import React, {Component} from 'react';
import {Form, Col, Row} from 'react-bootstrap';
import {default as ReactSelect} from "react-select";

export default class SelectField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			meta: {error, warning, touched},
			multi,
			emptyText,
			sizes,
			clearable = false,
			options,
			onChangeHook,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "danger") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = error || warning
		}

		let option = null;
		for (let i = 0; i < options.length; i++) {
			if (input.value === options[i].value) {
				option = options[i];
				break;
			}
		}
		return (
			<Form.Group as={Row} controlId={input.name}>
				<Form.Label column xs={sizes && sizes[0] ? sizes[0] : 4}>{label}</Form.Label>
				<Col xs={sizes && sizes[1] ? sizes[1] : 8}>
					<ReactSelect
						name={input.name}
						clearable={clearable}
						backspaceRemoves={false}
						deleteRemoves={false}
						multi={multi}
						simpleValue={!multi}
						clearValueText="Vymazat"
						clearAllText="Vymazat vše"
						noResultsText="(nic nenalezeno)"
						placeholder={emptyText || (props.disabled ? "(není)" : "Vyberte")}
						className={touched && error ? "is-invalid" : null}
						options={options}
						{...props} {...input}
						styles={{
							control: (provided, state) => {
								const r = {
									...provided
								};
								if (touched && error) {
									r.borderColor = "#dc3545";
								}
								return r;
							},
							valueContainer: (provided, state) => ({
								...provided,
								paddingLeft: ".5rem",
								marginLeft: 0
							}),
							singleValue: (provided, state) => ({
								...provided,
								marginLeft: 0
							})
						}}
						onChange={(value) => {
							if (onChangeHook) {
								onChangeHook(value.value);
							}
							return input.onChange(value.value)
						}}
						onBlur={() => {
							return input.onBlur(input.value)
						}}
						value={option}
					/>
					{message ? <div className={"text-" + validationState}>{message}</div> : null}
				</Col>
			</Form.Group>
		);
	}
}
